import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

export default function FeedbackView({ type, message, onClose }) {
    if (type === null) {
        return null;
    }

    const DeleteButton = ComponentRegistry.get("DeleteButton");
    const className = type === "error" ? "danger" : type;

    return (
      <div>
          <div className={`alert alert-${className} has-icon clearfix`} role="alert" onClick={onClose}>
              {message}
          </div>
      </div>
    );
}

FeedbackView.propTypes = {
    type: PropTypes.string,
    message: PropTypes.string,
    onClose: PropTypes.func,
};

FeedbackView.defaultProps = {
    type: null,
    message: null,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Basket/Views/FeedbackView.jsx